import { isSocialTrafficSource } from "@/components/AdobeDataLayer/utils";
import { CohesionSnippetConfig } from "@redventures/cohesion-utils-react";

const BASE_PATH = "/learn/xfinity-internetplus-west-rv-alpha";

export const COHESION_PROXY = {
  COHESION: `${BASE_PATH}/prx/c/c.js`,
  FUSE: `${BASE_PATH}/prx/f`,
  TAGULAR: `${BASE_PATH}/prx/t/v2/t`,
  MONARCH: `${BASE_PATH}/prx/m`,
};

const TAGULAR_WRITE_KEY = process.env.TAGULAR_WRITE_KEY;
const TAGULAR_SOURCE_KEY = process.env.TAGULAR_SOURCE_KEY;
const MONARCH_SOURCE_ID = process.env.MONARCH_SOURCE_ID;
const MONARCH_TOKEN = process.env.MONARCH_TOKEN;

const FUSE_POOL_ID = "pLgk3ozTG7hA2kCfLZHVw6";

const FUSE_CONFIG_ENABLED = {
  enabled: true,
  endpoint: COHESION_PROXY.FUSE,
  leases: [
    {
      pool: FUSE_POOL_ID,
    },
  ],
  cookieDomain: ".xfinity.com",
} as const;

const FUSE_CONFIG_DISABLED = {
  enabled: false,
  endpoint: COHESION_PROXY.FUSE,
  leases: [],
  cookieDomain: ".xfinity.com",
} as const;

export const COHESION_CONFIG = {
  cookieDomain: ".xfinity.com",
  writeKey: TAGULAR_WRITE_KEY,
  sourceKey: TAGULAR_SOURCE_KEY,
  domainAllowlist: ["www.stg.xfinity.com", "xfinity.com", "www.xfinity.com"],
  fuse: FUSE_CONFIG_ENABLED,
  tagular: {
    writeKey: TAGULAR_WRITE_KEY,
    sourceKey: TAGULAR_SOURCE_KEY,
    cookieDomain: ".xfinity.com",
    apiVersion: "v2/t",
    apiHost: COHESION_PROXY.TAGULAR,
    pageScrolledDistance: [1, 25, 50, 75, 100],
  },
  monarch: {
    enabled: true,
    sourceId: MONARCH_SOURCE_ID,
    token: MONARCH_TOKEN,
    endpoint: COHESION_PROXY.MONARCH,
    simulatedEvents: {
      enabled: true,
    },
    cookies: ["SC", "PSC"],
    autoRequest: {
      enabled: true,
      suppressPlacements: true,
      timeout: 8000,
      params: {
        writeKey: TAGULAR_WRITE_KEY,
        makeSourceUid: TAGULAR_SOURCE_KEY,
      },
    },
  },
  consent: {
    enabled: true,
    map: {
      C0001: "1",
      C0002: "2",
      C0003: "5",
      C0004: "4",
      C0005: "C0005",
    },
    onetrust: {
      enabled: true,
      optIn: false,
      timeout: 3000,
    },
    required: true,
    cookieClassification: "2",
    domain: ".xfinity.com",
  },
} as unknown as CohesionSnippetConfig;

/**
 * Social LPs serve a static permalease and must not request Fuse leases.
 * BAU keeps the default Fuse-enabled config.
 *
 * Note: this app uses `output: "export"`, so route-scoped config is applied via
 * pathname (client CohesionSnippet) rather than middleware/request headers.
 */
export function getCohesionConfigForPathname(
  pathname?: string | null,
  baseConfig: CohesionSnippetConfig = COHESION_CONFIG
): CohesionSnippetConfig {
  if (!isSocialTrafficSource(pathname)) {
    return baseConfig;
  }

  return {
    ...baseConfig,
    fuse: FUSE_CONFIG_DISABLED,
  } as unknown as CohesionSnippetConfig;
}
